/**
 * Tracks in-progress form drafts so pull-to-refresh cannot silently wipe them (MOB-02 / G8).
 * Prefer `data-customer-form-dirty="true"` on draft surfaces; counter is for programmatic scopes.
 */

let dirtyFormCount = 0;

/** DOM marker for unsaved draft surfaces (ReceiptLocales, claim, etc.). */
export const CUSTOMER_FORM_DIRTY_ATTR = 'data-customer-form-dirty';

export function isCustomerFormDirty(): boolean {
  if (dirtyFormCount > 0) {
    return true;
  }
  if (typeof document === 'undefined') {
    return false;
  }
  return document.querySelector(`[${CUSTOMER_FORM_DIRTY_ATTR}="true"]`) !== null;
}

export function setCustomerFormDirty(active: boolean): void {
  if (active) {
    dirtyFormCount += 1;
    return;
  }
  dirtyFormCount = Math.max(0, dirtyFormCount - 1);
}

export function resetCustomerFormDirtyGateForTests(): void {
  dirtyFormCount = 0;
}
